var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { useContext } from "react";
import { SiteContext } from "../components/context/site-context";
import { DEFAULT_SITE } from "../constants";
import { toNumber } from 'lodash';
export function useSite() {
  var defaultSite = {
    logoVerticalOffset: toNumber(process.env.LOGO_VERTICAL_OFFSET || 0),
    logoHorizontalOffset: toNumber(process.env.LOGO_HORIZONTAL_OFFSET || 0),
    logoVerticalOffsetMobile: toNumber(process.env.LOGO_VERTICAL_OFFSET_MOBILE || 0),
    logoHorizontalOffsetMobile: toNumber(process.env.LOGO_HORIZONTAL_OFFSET_MOBILE || 0),
    logoVerticalOffsetTablet: toNumber(process.env.LOGO_VERTICAL_OFFSET_TABLET || 0),
    logoHorizontalOffsetTablet: toNumber(process.env.LOGO_HORIZONTAL_OFFSET_TABLET || 0),
    logoVerticalOffsetDesktop: toNumber(process.env.LOGO_VERTICAL_OFFSET_DESKTOP || 0),
    logoHorizontalOffsetDesktop: toNumber(process.env.LOGO_HORIZONTAL_OFFSET_DESKTOP || 0),
    logoHeightMobile: toNumber(process.env.LOGO_HEIGHT_MOBILE || 36),
    logoHeightTablet: toNumber(process.env.LOGO_HEIGHT_TABLET || 52),
    logoHeightDesktop: toNumber(process.env.LOGO_HEIGHT_DESKTOP || 66),
    headerHeightMobile: toNumber(process.env.SITE_HEADER_HEIGHT_MOBILE) || 64,
    headerHeightTablet: toNumber(process.env.SITE_HEADER_HEIGHT_TABLET) || 78,
    headerHeightDesktop: toNumber(process.env.SITE_HEADER_HEIGHT_DESKTOP) || 100,
    loginLabel: process.env.LOGIN_LABEL || 'Login'
  };
  var siteFromContext = useContext(SiteContext);
  return __assign(__assign({}, defaultSite), siteFromContext || DEFAULT_SITE);
}